import { defineCapability } from './internal';
import { args } from '../common/args';
export const GLOBAL_KEYBOARD_SHORTCUT_HANDLER_CAP = defineCapability({
  name: 'GLOBAL_KEYBOARD_SHORTCUT_HANDLER_CAP',
  args: {
    keyboardEventKeys: args.keyboardEventKeys()
  }
});